'use strict';

var allTasksDone = require('./allTasksDone');
var hideMoreOrLessLinks = require('./hideMoreOrLessLinks');

function toggleTasks ($marketingChecklist) {
  var $tasksList = $marketingChecklist.find('.marketing-checklist-list');
  var $tasks = $tasksList.find('.task-container');
  var showToDo = $tasksList.hasClass('show-todo');
  var open = $tasksList.hasClass('open');
  var defaultTaskShown = 3;
  var $activeTasks;
  var $activeTasksFiltered;

  $tasks.addClass('hidden');

  if (showToDo === true) {
    $activeTasks = $tasks.not('.checked');
  } else {
    $activeTasks = $tasks.filter('.checked');
  }

  if (open === true) {
    $activeTasksFiltered = $activeTasks.not('.filtered-out');
  } else {
    $activeTasksFiltered = $activeTasks.not('.filtered-out')
      .filter(function (index) {
        return index < defaultTaskShown;
      });
  }

  $activeTasksFiltered.removeClass('hidden');
  $tasks.find('.label').addClass('hidden');
  $tasks.not('.checked').first().find('.label').removeClass('hidden');
  allTasksDone($marketingChecklist);
  return hideMoreOrLessLinks($marketingChecklist);
}

module.exports = toggleTasks;
